<template>
  <div class="container is-fluid">
    <div class="tile is-ancestor has-text-left">
      <div class="tile is-vertical is-parent">
        <div class="tile is-child">
          <p class="title has-text-left">
            Help
          </p>
        </div>
        <div class="tile is-child">
          <h4>
            To start with ValChrom see tutorial material: <a target=”_blank”
                                                             href="https://sisu.ut.ee/lcms_method_validation/14-valchrom">here</a>.
          </h4>
          <hr>
          <h4>Instructions for different validation steps and proccess flows.</h4>
          <br>
          <span v-for="file in files">
            <help-button-component :url="`${domain}`+file.fileLocation" :as_icon="false"
                                   :link_text=file.linkTitle></help-button-component>
          </span>
          <hr>
          <h4>General flowchart of ValChrom.</h4>
          <br>
          <span>Click on highlighted areas when hovering over ValChrom sections on the flowchart to open help PDF file.</span>
          <div class='card-content is-flex is-horizontal-center'>
            <figure class='image'>
              <img src="@/assets/FlowChart_horizontal.png" alt="ValChrom's flowchart" usemap="#flowchart-map">
              <map name="flowchart-map">
                <area class="methods" shape="rect" alt="methods" href="/media/help/methods.pdf">
                <area class="validation-plan" shape="rect" alt="validation-plan" href="/media/help/templates.pdf">
                <area class="experiment-plan" shape="rect" alt="experiment-plan" href="/media/help/plans.pdf">
                <area class="dataset" shape="rect" alt="dataset" href="/media/help/datasets.pdf">
                <area class="report" shape="rect" alt="report" href="/media/help/reports.pdf">
              </map>
            </figure>
          </div>
          <hr>
          <h4>Tutorial videos</h4>
          <br>
          <div>
            <iframe class="tutorial-video" allowfullscreen src="https://www.youtube.com/embed/ilDHv9sI1Gw"></iframe>
          </div>
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelpButtonComponent from "@/components/features/buttons/HelpButtonComponent";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      files: [
        {
          linkTitle: "Analytical methods: views and flows.",
          fileLocation: 'media/help/methods.pdf'
        },
        {
          linkTitle: "Validation plan: views and flows.",
          fileLocation: 'media/help/templates.pdf'
        },
        {
          linkTitle: "Experimental plan: views and flows.",
          fileLocation: 'media/help/plans.pdf'
        },
        {
          linkTitle: "Experimental dataset: views and flows.",
          fileLocation: 'media/help/datasets.pdf'
        },
        {
          linkTitle: "Report: views and flows.",
          fileLocation: 'media/help/reports.pdf'
        },
      ]
    }
  },
  name: 'HelpComponent',
  components: {
    HelpButtonComponent
  },
  computed: {
    ...mapGetters([
      'domain'
    ])
  }
}
</script>

<style scoped>
a:hover {
  color: limegreen;
}


.tutorial-video {
  width: 560px;
  height: 315px
}

area:hover {
  opacity:30%;
  background-color: #42b983;
}

area {
  position:absolute;
  display:block;
}

.methods {
  top: 57%;
  left: 16%;
  width: 15%;
  height: 32%;
}

.validation-plan {
  top: 14%;
  left: 16%;
  width: 15%;
  height: 32%;
}

.experiment-plan {
  top: 34%;
  left: 35%;
  width: 13%;
  height: 32%;
}

.dataset {
  top: 33%;
  left: 72%;
  width: 13%;
  height: 32%;
}

.report {
  top: 33%;
  left: 87%;
  width: 12.5%;
  height: 32%;
}

</style>